import { render, staticRenderFns } from "./indexz.vue?vue&type=template&id=7bce141d&"
import script from "./indexz.vue?vue&type=script&lang=js&"
export * from "./indexz.vue?vue&type=script&lang=js&"
import style0 from "./indexz.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "indexz.vue"
export default component.exports